<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'PageComponent.vue'
}
</script>

<style scoped></style>
